import React from 'react'

import theme from '../styles/theme'
import { rem, media } from '../styles/tools'

import Space from './Space'
import Wrapper from './Wrapper'
import BarColumn from './BarColumn'
import AdVictoremLogo from './AdVictoremLogo'

const Shell = ({ children, ...props }) => (
  <Wrapper as="main" css={{ display: 'flex' }} {...props}>
    <div css={{ flexGrow: 1 }}>{children}</div>
    <BarColumn css={{ [media.max.laptop]: { display: 'none' } }}>
      <Space y="15vh" />
      <div
        css={{
          position: 'sticky',
          top: `calc(100vh - ${rem(180 + theme.space.lg)})`,
          willChange: 'transform',
        }}
      >
        <div
          css={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <AdVictoremLogo rotated />
        </div>
      </div>
    </BarColumn>
  </Wrapper>
)

export default Shell
